export async function handleGDPR(): Promise<boolean> {
  try {
    // The web-wrapper knows if we are in the EU or not. ($mediavine.web.model.gdpr)
    // Make sure it's loaded before continuing
    await waitForWrapper()
  } catch (error) {
    // Waited too long for web-wrapper launcher to load.
    // Disable personal ads and continue.
    return Promise.resolve(true)
  }

  const qp = new URLSearchParams(window.location.search)
  const model = window.$mediavine.web.model
  const IS_EU: boolean = model.gdpr === '1'
  const isGdprTest = qp.get('test') === 'gdpr'
  const enableGDPR: boolean =
    (IS_EU && model.gdpr_compliance === 1) || isGdprTest

  if (!window || !enableGDPR) {
    return Promise.resolve(false)
  }

  const serveNonPersonalAds = await waitForConsentResponse()

  return Promise.resolve(serveNonPersonalAds)
}

async function waitForConsentResponse(): Promise<boolean> {
  return new Promise((resolve: (result: boolean) => void) => {
    if (!window.__cmp && !window.__tcfapi) {
      resolve(true)
    } else {
      if (window.__cmp) {
        window.__cmp('getVendorConsents', '', (result: ICMPResult) => {
          // eslint-disable-next-line no-magic-numbers
          if (!(result.vendorConsents[5] && result.purposeConsents[2])) {
            resolve(true)
          } else {
            resolve(false)
          }
        })
      }
      if (window.__tcfapi) {
        window.__tcfapi(
          'getTCData',
          2,
          (tcData: ITCFResult, success: boolean) => {
            if (success) {
              resolve(true)
            } else {
              resolve(false)
            }
          }
        )
      }
    }
  })
}

// Wait for the web-launcher and web-wrapper to load.  If video is lazy-loading
// it should always already be loaded.
async function waitForWrapper(): Promise<void> {
  const isReady = () => {
    return (
      window.$mediavine &&
      window.$mediavine.web &&
      window.$mediavine.web.model &&
      window.$mediavine.web.initialized &&
      window.$mediavine.web.videoOptionsSet &&
      window.$mediavine.web.getVideoAdTagAndHighBid &&
      window.$mediavine.web.getNextVideoAdTagAndHighBid &&
      window.$mediavine.web.getNonLinearVideoAdTag &&
      window.pbjs
    )
  }

  return new Promise((resolve, reject) => {
    if (isReady()) {
      console.info('window.$mediavine.web.model already existed')
      return resolve()
    }

    // See if the web-launcher script is on the page at all
    const selectors = [
      `script[src*='scripts.mediavine.com/tags/']`,
      `script[src*='scripts-staging.mediavine.com/tags/']`,
      `script[src*='localhost:8080/tags/']`
    ].join(',')
    const scripts = document.querySelectorAll(selectors) as NodeListOf<
      HTMLScriptElement
    >

    if (scripts.length === 0) {
      // mediavine launcher script not on page, no use waiting for it to show up
      return reject('web-wrapper tag script not found')
    }

    const wait = 3000
    const start = Date.now()
    const interval = setInterval(() => {
      if (isReady()) {
        clearInterval(interval)
        return resolve()
      }

      if (Date.now() - start > wait) {
        clearInterval(interval)
        return reject('web-wrapper loading timed out')
      }
    }, 100)
  })
}

interface ICMPResult {
  vendorConsents: {}[]
  purposeConsents: {}[]
  metadata: any
}

interface ITCFResult {
  vendor: {
    consents: boolean
    legitimateInterests: boolean
  }
}
